require('./cardsBoxHeaderControlToggle.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
//@constants
const { CARD_SIZE_MEDIUM } = require('constants/index');
//@actions
const { switchCardControlOn, switchCardControlOff, resetCardControl } = require('actions/cardControl');
const CardsToggleButton = require('components/cards/cardsToggleButton/cardsToggleButton');
class CardsBoxHeaderControlToggle extends React.Component {

    buildModalContent() {
        const { 
            cardFieldCheck,
            immCard,
            immCardToggle,
            immVariables,
        } = this.props;
        const cardOn = immCard.get(cardFieldCheck);
        const isInfirstStep = !immCardToggle.get('success') && !immCardToggle.get('error') && !immCardToggle.get('inProgress');
        const onCloseCallback = immCardToggle.get('inProgress') ? null : this.handleToggleModal;
        let content, titleLabel, submitLabel;
        let primaryButtonText;
        let primaryButtonDisabled = false;
        let primaryButtonCallback;
        let secondaryButtonText;
        let secondaryButtonCallback;
        let footerType;
        let title;

        if (isInfirstStep) {

            if (cardOn) {
                titleLabel = 'cardsControl-offTitle';
                submitLabel = 'cardsControl-offSubmit';
            } else {
                titleLabel = 'cardsControl-onTitle';
                submitLabel = 'cardsControl-onSubmit';
            }

            content = (
                <section className="cards-control-toggle__modal-content">
                    <CommercialAds path="cards" type="cards" immCard={immCard} size={CARD_SIZE_MEDIUM} />
                </section>
            );
            primaryButtonText = submitLabel;
            primaryButtonCallback = cardOn ? this.handleClickOff : this.handleClickOn;
            secondaryButtonText = 'common-cancel';
            secondaryButtonCallback = this.handleToggleModal;
            footerType = 'navigation';
            title = formatText(titleLabel, [
                immCard.getIn(['alias', 'current']),
                getLastNChars(immCard.get('number'), 4, '*')
            ]);
        } else if (immCardToggle.get('inProgress')) {

            titleLabel = cardOn ? 'cardsControl-loadingOffTitle' : 'cardsControl-loadingOnTitle';

            content = (
                <section className="cards-control-toggle__modal-content">
                    <LoadingSection />
                </section>
            );
            primaryButtonDisabled = true;
            primaryButtonText = 'cardsControl-understand';
            footerType = 'navigation';
            title = formatText(titleLabel, [
                immCard.getIn(['alias', 'current']),
                getLastNChars(immCard.get('number'), 4, '*')
            ]);
        } else {
            let textLabel, warningElement, cardImageElement, titleInjectedStrings, bodyInjectedStrings;

            if (immCardToggle.get('error')) {
                titleLabel = 'cardsControl-errorTitle';
                bodyInjectedStrings = [
                    immCard.getIn(['alias', 'current']),
                    getLastNChars(immCard.get('number'), 4, '*'),
                    immVariables.getIn(['telefono', 'cliente'])
                ];
                textLabel = cardOn ? 'cardsControl-offErrorText' : 'cardsControl-onErrorText';
            } else {
                titleLabel = cardOn ? 'cardsControl-onTitleConfirmation' : 'cardsControl-offTitleConfirmation';
                textLabel = cardOn ? 'cardsControl-onText' : 'cardsControl-offText';
                titleInjectedStrings = [
                    immCard.getIn(['alias', 'current']),
                    getLastNChars(immCard.get('number'), 4, '*')
                ];

                cardImageElement = (
                    <section className="cards-control-toggle__modal-content">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size={CARD_SIZE_MEDIUM} />
                    </section>
                );

                if (!cardOn) {
                    warningElement = (
                        <div className="cards-control-toggle__modal-body-text cards-control-toggle__modal-body-text--highlighted">
                            <FormattedText
                                className="cards-control-toggle__modal-body-text--highlighted"
                                value="cardsControl-offTextWarn"
                            />
                        </div>
                    );
                }

                primaryButtonCallback = this.handleToggleModal;
                primaryButtonText = 'cardsControl-understand';
                footerType = 'navigation';
            }

            title = formatText(titleLabel, titleInjectedStrings);
            content = (
                <article>
                    <section className="cards-control-toggle__modal-body">
                        {cardImageElement}
                        <div className="cards-control-toggle__modal-body-text">
                            <FormattedText value={textLabel} injectedStrings={bodyInjectedStrings} />
                        </div>
                        {warningElement}
                    </section>
                </article>
            );
        }

        return (
            <OKModal
                content={content}
                footerType={footerType}
                isOpen={this.state.modalOpen}
                onCloseCallback={onCloseCallback}
                onPrimaryButtonClick={primaryButtonCallback}
                onSecondaryButtonClick={secondaryButtonCallback}
                primaryButtonDisabled={primaryButtonDisabled}
                primaryButtonText={primaryButtonText}
                secondaryButtonText={secondaryButtonText}
                shouldCloseOnOverlayClick={false}
                title={title}
            />
        );
    }

    render() {
        const { immCard, immVariables, cardIndex } = this.props;
        return (
            <div className="cards-control-toggle">
                <CardsToggleButton
                    buildModalContent={this.buildModalContent}
                    tooltipOff={'cardsControl-offTooltip'}
                    tooltipOnSubmit={'cardsControl-onSubmit'}
                    reducerStateName={'cardControlOn'}
                    immCard={immCard}
                    immVariables={immVariables}
                    cardFieldCheck={'control'}
                    description={'cardsControl-toggle_description'}
                    resetCardToggle={this.props.resetCardControl}
                    switchCardToggleOff={this.props.switchCardControlOff}
                    switchCardToggleOn={this.props.switchCardControlOn}
                    cardIndex={cardIndex}
                />
            </div>
        );
    }
}

CardsBoxHeaderControlToggle.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardToggle: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    cardFieldCheck: PropTypes.string,
    resetCardControl: PropTypes.func.isRequired,
    switchCardControlOff: PropTypes.func.isRequired,
    switchCardControlOn: PropTypes.func.isRequired,
    cardIndex: PropTypes.number,
}


const mapDispatchToProps = {
    resetCardControl,
    switchCardControlOff,
    switchCardControlOn
};

module.exports.constructor = CardsBoxHeaderControlToggle;
module.exports.CardsBoxHeaderControlToggle = connect(null, mapDispatchToProps)(CardsBoxHeaderControlToggle);
